export enum PoolInstance {
    AT = 'at',
    CH = 'ch',
    Unknown = 'Unknown',
}

/**
 * The current pool instance configuration for the application.
 *
 * This constant retrieves the pool instance from the environment variable `NX_PUBLIC_APP_POOL_INSTANCE`.
 * If the environment variable is not set or invalid, it defaults to `PoolInstance.Unknown`.
 *
 * @deprecated Use `isInstance()` function instead to check the current pool instance.
 */
export const POOL_INSTANCE = (process.env['NX_PUBLIC_APP_POOL_INSTANCE'] as PoolInstance) ?? PoolInstance.Unknown;

export const isInstance = (instance: PoolInstance): boolean => instance.toLowerCase() === POOL_INSTANCE.toLowerCase();
